import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
    selector: 'ea-mix-chart',
    templateUrl: './ea-mix.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./ea-mix.component.scss'],
    standalone: false
})
export class EaMixComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;
  @Input() options: any;
  @Input() title: any;

  mixOptions: any;

  constructor() {}

  ngOnInit() {
    if (this.options) {
      this.mixOptions = this.options;
    }
  }
}
